import { Component, Input } from '@angular/core';

@Component({
  selector: 'nx-ng-ticket-delivery',
  templateUrl: './ticket-delivery.component.html',
  styleUrls: ['./ticket-delivery.component.scss'],
})
export class TicketDeliveryComponent {
  @Input()
  title = '';
}
